/*
ecommerce.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import {
  getSummary,
  trackCreditConsumption,
  getRemainingCredits
} from './httpClients/ecommerceClient'
import { ecommerceSummaryError } from './errors'
import { AxiosError } from 'axios'

export const ecommerceUnit = "scanpages"

export const fetchEcommerceSummary = (serial: string, appId: string) =>
  getSummary(serial, appId).then(r => {
    if (!r.isEntitled) {
      return ecommerceSummaryError(r)
    }
    return r
  })

export const trackEcommerceConsumption = (
  serial: string,
  appId: string,
  usage: number,
  unit: string
) => {

  return trackCreditConsumption(serial, appId, usage, unit)
    .then(r=>r)
}

export const getEcommerceRemainingCredits = (
  serial: string,
  appId: string,
  onError: (error: AxiosError) => void
) =>
  getRemainingCredits(serial, appId, ecommerceUnit)
    .then(r => r)
    .catch(e => onError(e))